import { useState } from "react";

import { Image, Modal, Close } from "./styles";

export default ({ src, alt, video, three_dimensional }) => {
  const [active, setActive] = useState(false);
  return (
    <>
      {video || three_dimensional ?
        <>
          <iframe width="350" height="300" src={src} frameborder="0" allowfullscreen=""></iframe>
        </>
        :
        <>
          <Image src={src} alt={alt} onClick={() => setActive(!active)} />

          {active && (
            <Modal onClick={() => setActive(!active)}>
              <Close>x</Close>
              <img style={{maxHeight: '100%'}} src={src.replace("large", "original")} alt={alt} />
            </Modal>
          )}
        </>
      }
    </>
  );
};
